import { get } from "@/application/api";

interface ClubContactApiResource {
  street: string | null;
  house_number: string | null;
  postal_code: string | null;
  city: string | null;
  email: string | null;
  phone_number: string | null;
}

interface ClubApiResource {
  id: string;
  name: string;
  logo: string | null;
  branding: { primary_color: string } | null;
  contact: ClubContactApiResource | null;
}

export interface ClubContact {
  street: string | null;
  houseNumber: string | null;
  postalCode: string | null;
  city: string | null;
  email: string | null;
  phoneNumber: string | null;
}

export interface ClubBranding {
  id: string;
  name: string;
  logo: string | null;
  primaryColor: string | null;
  contact: ClubContact | null;
}

const toClubContact = (resource: ClubContactApiResource): ClubContact => ({
  street: resource.street,
  houseNumber: resource.house_number,
  postalCode: resource.postal_code,
  city: resource.city,
  email: resource.email,
  phoneNumber: resource.phone_number,
});

const toClubBranding = (resource: ClubApiResource): ClubBranding => ({
  id: resource.id,
  name: resource.name,
  logo: resource.logo,
  primaryColor: resource.branding?.primary_color ?? null,
  contact: resource.contact ? toClubContact(resource.contact) : null,
});

export const getMyClubs = () =>
  get<ClubApiResource[]>("/v1/clubs/me").then((res) =>
    res.data.map(toClubBranding),
  );
